import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportIcon from "@mui/icons-material/Report";
import { APP_COLORS } from "../../../../utils/constants";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

export default function NotificationModal({
  openModal,
  setOpenModal,
  apiResponse,
  setApiResponse,
}) {
  // const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <div>
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={style}>
          {apiResponse.status === "success" ? (
            <CheckCircleIcon sx={{ color: "limegreen", fontSize: 50 }} />
          ) : (
            <ReportIcon color="warning" sx={{ fontSize: 50 }} />
          )}
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ textAlign: "center" }}
          >
            {apiResponse.status === "success"
              ? "Thank You " + apiResponse?.user?.firstName + "!"
              : "Couldn't send your message!"}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {apiResponse.status === "success"
              ? "We have received your message and are excited to connect with you soon!"
              : "You can contact us directly via Email:"}
          </Typography>{" "}
          {apiResponse.status === "error" && (
            <Box sx={{ pt: 2 }}>
              <Button
                variant="contained"
                component="a"
                href="mailto:inquiry@rubiconbpe.com?subject=Hello&body=This%20is%20a%20test"
                sx={{
                  backgroundColor: APP_COLORS.MAIN_LIGHT,
                  borderRadius: "40px",
                  mx: 1,
                }}
                endIcon={<ForwardToInboxIcon />}
              >
                Send Email
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  );
}
